export const connectIDConfig = {
    // Directory URLs
    participantsUrl: 'https://data.directory.connectid.com.au/participants',
    relyingPartyUrl: 'https://rp.directory.sandbox.connectid.com.au/openid_relying_party/280518db-9807-4824-b080-324d94b45f6a',
    
    // Client Configuration
    clientId: '280518db-9807-4824-b080-324d94b45f6a',
    redirectUri: (() => {
      const baseUrl = process.env.REACT_APP_BASE_URL || 'http://127.0.0.1:8000/api';
      const baseWithoutApi = baseUrl.replace(/\/api$/, '');
      return `${baseWithoutApi}/api/v1/connectid/auth/callback`;
    })(),
    frontendCallbackUrl: 'http://127.0.0.1:8000/onboarding/id-verfication',
    
    
    // API Configuration
    // baseUrl: (() => {
    //   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://127.0.0.1:8000/api';
    //   const baseWithoutApi = baseUrl.replace(/\/api$/, '');
    //   return `${baseWithoutApi}/`;
    // })(),
    // apiBase: process.env.REACT_APP_BASE_URL || 'http://127.0.0.1:8000/api',
    baseUrl: process.env.REACT_APP_BASE_URL || 'http://http://127.0.0.1:8000/',
    apiBase: process.env.REACT_APP_BASE_URL + '/v1' || 'http://127.0.0.1:8000/api/v1',
    origin: 'http://localhost:3000',
    
    // API Endpoints
    endpoints: {
      participants: '/v1/connectid/participants',
      selectBank: '/v1/connectid/select-bank',
      callback: '/v1/connectid/auth/callback',
      verify: '/v1/connectid/verify'
    },
  
    // Request Configuration
    requestConfig: {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Origin': 'http://localhost:3000'
      }
    },
  
    // Claims Configuration
    defaultClaims: {
      given_name: { essential: true },
      middle_name: { essential: true },
      family_name: { essential: true },
      // birthdate: { essential: true },  
      // email: { essential: true },
      // address: { essential: true },
      // phone_number: { essential: true }
    }
  };
  